export const APP_NAME = 'MorphERD'
export const SYSTEM_VERSION = '0.3.0'
